import { render, staticRenderFns } from "./CartaoRecebimentosNovos.vue?vue&type=template&id=ae8388c4&scoped=true"
import script from "./CartaoRecebimentosNovos.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoRecebimentosNovos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoRecebimentosNovos.vue?vue&type=style&index=0&id=ae8388c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8388c4",
  null
  
)

export default component.exports